// Configuration globale par défaut pour la bibliothèque de composants

export const DEFAULT_CONFIG = {
  locale: 'fr-FR',
  datepicker: {
    firstDayOfWeek: 1, // 1 = Lundi, 0 = Dimanche
    months: [
      'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ],
    monthsShort: [
      'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jui',
      'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'
    ],
    weekdays: [
      'Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'
    ],
    weekdaysShort: [
      'Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'
    ],
    weekdaysMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    format: 'DD/MM/YYYY',
    placeholder: 'Sélectionner une date'
  },
  timepicker: {
    placeholder: 'Sélectionner une heure',
    format: '24h', // '24h' ou '12h'
    step: 15,      // intervalle par défaut en minutes
  },
  select: {
    placeholder: 'Sélectionner une option',
    noResultsText: 'Aucun résultat trouvé',
    searchText: 'Rechercher...'
  }
};

/**
 * Récupère une valeur de configuration en combinant les options par défaut
 * et les surcharges définies par l'utilisateur dans window.UI_CONFIG.
 * 
 * @param {string} component - Nom du composant ('datepicker', 'timepicker', 'select') ou 'locale'
 * @param {string} path - Chemin de la clé interne (ex: 'placeholder')
 * @returns {any} Valeur configurée
 */
export function getConfig(component, path = '') {
  const globalConfig = window.UI_CONFIG || {};
  
  const getNestedValue = (obj, keyPath) => {
    if (!keyPath) return obj;
    return keyPath.split('.').reduce((acc, part) => {
      return acc && acc[part] !== undefined ? acc[part] : undefined;
    }, obj);
  };

  const defaultValue = getNestedValue(DEFAULT_CONFIG, path ? `${component}.${path}` : component);
  const userValue = getNestedValue(globalConfig, path ? `${component}.${path}` : component);

  return userValue !== undefined ? userValue : defaultValue;
}
